import { render, staticRenderFns } from "./feeSettlementDetails.vue?vue&type=template&id=ecbbb006&scoped=true&"
import script from "./feeSettlementDetails.vue?vue&type=script&lang=js&"
export * from "./feeSettlementDetails.vue?vue&type=script&lang=js&"
import style0 from "./feeSettlementDetails.vue?vue&type=style&index=0&id=ecbbb006&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecbbb006",
  null
  
)

export default component.exports